import { combineReducers } from "redux";
import { Action } from "./actions";

export interface SelectionState {
  hoveredPeak: string | null;
  clickedPeak: string | null;
  zoomedPeak: string | null;
  hoveredImage: string | null;
}

export interface State {
  selection: SelectionState;
}

const initState: SelectionState = {
  hoveredPeak: null,
  clickedPeak: null,
  zoomedPeak: null,
  hoveredImage: null
};

const selection = (
  state: SelectionState = initState,
  action: Action
): SelectionState => {
  switch (action.type) {
    case "HOVER_PEAK":
      return { ...state, hoveredPeak: action.payload };
    case "CLICK_PEAK":
      return { ...state, clickedPeak: action.payload };
    case "SET_ZOOM_PEAK":
      return { ...state, zoomedPeak: action.payload };
    case "HOVER_IMAGE":
      return { ...state, hoveredImage: action.payload };
    default:
      return state;
  }
};

export default combineReducers<State>({
  selection
});
